import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';
import { map, of, tap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PropertyService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {
		//
	}
	loadPropertyInit(cohortId: any) {
		return this.ngrxService.loadInitAPI('Property', 'list', cohortId);
	}

	loadPropertyApi(cohortId: any) {
		return this.getPropertyLists(cohortId).pipe(
			map((data: any) => {
				return this.ngrxService.loadInitData('Property', 'list', cohortId, {
					data: data,
				});
			}),
		);
	}

	bulkUpdate(cohortId: any, properties: Array<any>) {
		return this.http
			.post(
				`${environment.url.cohort}/${cohortId}/bulk/cohort/property`,
				properties,
			)
			.pipe(
				tap(() => {
					this.loadPropertyApi(cohortId).subscribe();
				}),
			);
	}

	copyProperty(toCohortId: any, fromCohortId: any) {
		return this.http
			.post(
				`${environment.url.cohort}/copy/cohort/property/fromCohort/${fromCohortId}/toCohort/${toCohortId}`,
				{},
			)
			.pipe(
				tap(() => {
					this.loadPropertyApi(toCohortId).subscribe();
				}),
			);
	}

	fetchPropertyData(cohortId: any) {
		return this.ngrxService
			.loadData('Property', 'list', cohortId)
			.pipe(map((data: any) => data.data));
	}
	getPropertyLists(cohortId: any) {
		return this.http.get(
			environment.url.cohort + `/list/cohort/${cohortId}/property`,
			// return this.http.get(environment.url.cohort + '/list/cohort/$id/property');
		);
	}

	getCohortList(cohortId: any) {
		return this.http
			.get(`${environment.url.cohort}/course/${cohortId}/cohorts`)
			.pipe(
				map((d: any) =>
					d.map((a: any) => ({
						...a,
						name: `[${a.id}] : ${a.alias}`,
					})),
				),
			);
	}
}
